import React from 'react';
import { createUseStyles } from 'react-jss';
import { cssColorPrimary, cssSpacingXs } from '../constants/globalcss';

const useStyles = createUseStyles({
  label: {
    color: cssColorPrimary,
    display: 'block',
    fontSize: '15px',
    fontWeight: 600,
    letterSpacing: '0.01em',
    marginBottom: cssSpacingXs,
    textAlign: 'left',
    whiteSpace: 'normal',
    width: '100%',
    wordBreak: 'break-word',
  },
  labelCentered: {
    textAlign: 'center',
  },
  required: {
    color: 'red',
    fontSize: '16px',
    marginTop: '2px',
  },
});

function Label(props: ILabelProps) {
  const classes = useStyles();
  const style = props.width ? { width: props.width } : undefined;
  const className =
    props.align === 'center'
      ? `${classes.label} ${classes.labelCentered}`
      : classes.label;

  return (
    <label className={className} htmlFor={props.htmlFor} style={style}>
      {props.text}
      {props.required && <span className={classes.required}>&nbsp;*</span>}
    </label>
  );
}

export interface ILabelProps {
  text: string;
  required?: boolean;
  htmlFor?: string;
  width?: string | number;
  /** When `center`, label text is centered (e.g. stacked field columns). */
  align?: 'left' | 'center';
}

export default Label;
